import { z } from "zod";

const schema = z.object({
	prices: z.object({
		sei: z.number(),
	}),
});

export { schema };
